import { useContext } from 'react';

import { RegisterContext, type RegisterContextType } from '../context/register.context';

export const useRegisterContext = (): RegisterContextType => {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error('useRegisterContext must be used within a RegisterProvider');
  }
  return context;
};
